import { Tabs as TABTYPES } from 'components/reportDashboard/configs';
import React, { useState } from 'react';
import { TabConfig } from 'widgets/tabs/types';
import { TabButton, TabContent, TabsContainer, TabsWrapper } from './styles';

export type TabsProps = {
    tabs: TabConfig[];
    defaultTab: TABTYPES;
    onChange: (tabId: string) => void;
};

const Tabs: React.FC<TabsProps> = ({ tabs, defaultTab, onChange }) => {
    const [active, setActive] = useState<TABTYPES>(defaultTab);

    const activeTabConfig = tabs.find((tab) => tab.id === active);

    const onChangeTabHandler = (id: TABTYPES) => {
        setActive(id);
        onChange(id);
    };

    return (
        <TabsWrapper>
            <TabsContainer>
                {tabs.map((tab) => (
                    <TabButton
                        key={tab.id}
                        active={tab.id === active}
                        onClick={() => onChangeTabHandler(tab.id)}
                    >
                        {tab.label}
                    </TabButton>
                ))}
            </TabsContainer>

            <TabContent>{activeTabConfig?.component}</TabContent>
        </TabsWrapper>
    );
};

export default Tabs;
